import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as BenefitsTypesActions,
  Selectors as BenefitsTypesSelectors,
} from "store/ducks/benefitsTypes";

import { Access } from "common";
import { Form, Loading } from "components";
import { Segments } from "components/Filters";
import { EPlanName } from "enums";

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
    edit: false,
  };

  componentDidMount() {
    const { getBenefitsTypesPlansRequest } = this.props;

    getBenefitsTypesPlansRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      this.setState({
        data: {
          ...this.props.data,
        },
        edit: this.props.data.id !== "",
      });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleToggleWelcomeVoucher = () => {
    const wasChecked = this.state.data.onboarding_only;

    if (!wasChecked) {
      return this.setState({
        data: {
          ...this.state.data,
          onboarding_only: true,
        },
      });
    }

    this.setState({
      data: {
        ...this.state.data,
        onboarding_only: false,
        onboarding_start_at: null,
        onboarding_end_at: null,
      },
    });
  };

  handleWelcomeVoucherDate = (key, value) => {
    this.setState({
      data: {
        ...this.state.data,
        onboarding_only: true,
        [`onboarding_${key}`]: value,
      },
    });
  };

  handleChangeInput = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeExtraDataInput = (e) => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({
      data: { ...data, extra_data: { ...data.extra_data, [name]: value } },
    });
  };

  handleChangeCheckbox = (name) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: !data[name] } });
  };

  handleChangeExtraDataCheckbox = (name) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: { ...data.extra_data, [name]: !data.extra_data[name] },
      },
    });
  };

  handleSelectPlans = (plan_ids) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        plan_ids: plan_ids.length ? plan_ids : "",
      },
    });
  };

  handleSelectSegments = (segments) => {
    const { data } = this.state;

    this.setState({ data: { ...data, segments } });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  isProPlanSelected(plans) {
    return (
      Array.isArray(plans) &&
      plans.some((plan) => plan.label === EPlanName.PRO_EXECUTOR)
    );
  }

  render() {
    const { data, edit } = this.state;
    const { errors, saving, plans } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes do Tipo de Benefício</h3>
        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            disabled={edit}
            name="title"
            placeholder="Digite o título do tipo de benefício"
            value={data.title}
            onChange={this.handleChangeInput}
            errors={errors.title}
          />
        </Form.Field>
        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.TextArea
            disabled={edit}
            name="description"
            placeholder="Descontos em produtos para cuidadar da sua piscina."
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
          />
        </Form.Field>
        <Form.Field>
          <Form.Label>Termo Legal</Form.Label>
          <Form.TextArea
            name="legal_term"
            placeholder="Termo Legal dos benefícios"
            value={data.extra_data.legal_term}
            onChange={this.handleChangeExtraDataInput}
          />
        </Form.Field>
        <Form.Field className="field-select">
          <Form.Label>Plano</Form.Label>
          <Form.Select
            isMulti
            isDisabled={edit}
            placeholder="Selecione planos"
            onChange={this.handleSelectPlans}
            value={data.plan_ids}
            options={plans.data}
            errors={errors.plan_ids}
          />
        </Form.Field>

        {this.isProPlanSelected(data.plan_ids) && (
          <Form.Field className="field-select">
            <Form.Label>Segmentos</Form.Label>
            <Segments
              value={data.segments}
              onChange={this.handleSelectSegments}
              isMulti
            />
          </Form.Field>
        )}

        <Form.Field className="checkbox-field">
          <Form.Label>EAD</Form.Label>
          <Form.Checkbox
            disabled={edit}
            checked={data.extra_data.gift}
            onChange={() => this.handleChangeExtraDataCheckbox("gift")}
          />
        </Form.Field>
        {data.extra_data.gift && (
          <Fragment>
            <Form.Field className="checkbox-field">
              <Form.Label>Utilizável</Form.Label>

              <Form.Checkbox
                disabled={edit}
                checked={data.usable}
                onChange={() => this.handleChangeCheckbox("usable")}
              />
            </Form.Field>

            <Form.Field className="checkbox-field">
              <Form.Label>Transferível</Form.Label>

              <Form.Checkbox
                disabled={edit}
                checked={data.transferable}
                onChange={() => this.handleChangeCheckbox("transferable")}
              />
            </Form.Field>

            {data.transferable && (
              <Form.Field>
                <Form.Label>Expira em:</Form.Label>
                <Form.Input
                  disabled={edit}
                  name="transferable_expires_in"
                  type="number"
                  placeholder="Digite o prazo para expirar"
                  value={data.extra_data.transferable_expires_in}
                  onChange={this.handleChangeExtraDataInput}
                />
              </Form.Field>
            )}
          </Fragment>
        )}
        <Form.Field className="checkbox-field">
          <Form.Label>Invalidável</Form.Label>

          <Form.Checkbox
            checked={data.extra_data.invalidable}
            onChange={() => this.handleChangeExtraDataCheckbox("invalidable")}
          />
        </Form.Field>
        <Form.Field className="checkbox-field">
          <Form.Label>Ativo</Form.Label>

          <Form.Checkbox
            checked={data.active}
            onChange={() => this.handleChangeCheckbox("active")}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Ativação Automática</Form.Label>

          <Form.Checkbox
            checked={data.automatically_activated}
            onChange={() =>
              this.handleChangeCheckbox("automatically_activated")
            }
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Voucher de Boas Vindas</Form.Label>
          <Form.Checkbox
            disabled={edit}
            checked={data.onboarding_only}
            onChange={this.handleToggleWelcomeVoucher}
          />
        </Form.Field>

        {data.onboarding_only && (
          <Fragment>
            <Form.Field
              className="datepicker-field"
              errors={errors.onboarding_start_at}
            >
              <Form.Label>Início</Form.Label>
              <Form.DatePicker
                disabled={edit}
                dateFormat="dd/MM/yyyy HH:mm"
                selected={data.onboarding_start_at}
                onChange={(value) =>
                  this.handleWelcomeVoucherDate("start_at", value)
                }
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                timeCaption="Hora"
                className={errors.onboarding_start_at && "parsley-error"}
              />

              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>

            <Form.Field
              className="datepicker-field"
              errors={errors.onboarding_end_at}
            >
              <Form.Label>Fim</Form.Label>
              <Form.DatePicker
                selected={data.onboarding_end_at}
                onChange={(value) =>
                  this.handleWelcomeVoucherDate("end_at", value)
                }
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={1}
                dateFormat="dd/MM/yyyy HH:mm"
                timeCaption="Hora"
                className={errors.onboarding_end_at && "parsley-error"}
                disabled={!data.onboarding_start_at || edit}
              />
              <div className="icon-input">
                <span className="glyph glyph-calendar" />
              </div>
            </Form.Field>
          </Fragment>
        )}

        <div className="buttons">
          <Link to="/benefits/types/list" className="button-cancel">
            Cancelar
          </Link>
          {Access.hasPermissions("edit-benefits") && (
            <Form.Button
              className="button-save"
              onClick={this.handleSubmit}
              disabled={saving}
            >
              {saving ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  plans: {
    ...state.benefitsTypes.plans,
    data: BenefitsTypesSelectors.plans(state.benefitsTypes.plans.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators(BenefitsTypesActions, dispatch);

export default connect(mapState, mapActions)(CustomForm);
